import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';

@Injectable()
export class CancelHttpOnRouteChangeInterceptor implements HttpInterceptor {
  private cancel$ = new Subject<void>();

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.cancel$.next(); // Cancela todas las peticiones pendientes
      }
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(takeUntil(this.cancel$));
  }
}
